import React from 'react';

const LicensingAdimin = () => {
    return (
        <div>LicensingAdimin</div>
    );
};

export default LicensingAdimin;